export const cacheImage = async (url) => {
    // Si es un dominio que NO permite CORS → NO intentamos cachear
    if (!url.includes("firebasestorage")) {
      return url;
    }
  
    const dbName = "ImageCacheDB";
    const storeName = "images";
  
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, 1);
  
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName);
        }
      };
  
      request.onerror = () => resolve(url); // fallback
  
      request.onsuccess = () => {
        const db = request.result;
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);
  
        const getReq = store.get(url);
  
        getReq.onsuccess = () => {
          if (getReq.result) {
            resolve(getReq.result);
          } else {
            fetch(url)
              .then((res) => res.blob())
              .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  const base64 = reader.result;
  
                  const tx2 = db.transaction(storeName, "readwrite");
                  tx2.objectStore(storeName).put(base64, url);
  
                  resolve(base64);
                };
                reader.readAsDataURL(blob);
              })
              .catch(() => resolve(url)); // fallback si CORS falla
          }
        };
      };
    });
  };
  